/* eslint-disable no-unused-vars */
import axios from "axios";
import { getUrl } from "@/common/config";
class MachineTestReportsApi {
  constructor() {
    this.url = getUrl();
  }

  /**
   * Get last cycle result by machine and type
   * Params:
   * @param {string} machineId
   * @returns {Object} promise with last result
   */
  async getLastCycle(machineId, type) {
    const params = {
      machineId,
      isFingerprint: false,
      skip: 0,
      limit: 1,
      sort: "-startTime",
      type
    };

    return axios.get(`${this.url}/cycles`, { params }).then(response => {
      return response.data.result;
    });
  }
  /**
   * Get last cycles result for each tools by machine for tools_check app
   * Params:
   * @param {string} machineId
   * @returns {Object} promise with last result
   */
  async getLastCyclesWithTool(machineId) {
    const distincttools = true;
    const params = {
      machineId,
      isFingerprint: false,
      distincttools
    };

    return axios.get(`${this.url}/cycles`, { params }).then(response => {
      return response.data.result;
    });
  }

  async getLastFingerprint(machineId, type) {
    const params = {
      machineId,
      isFingerprint: true,
      skip: 0,
      limit: 1,
      sort: "-startTime",
      type
    };
    return axios.get(`${this.url}/cycles`, { params }).then(response => {
      return response.data.result;
    });
  }

  /**
   * Get cycles by machine and app type
   * Params:
   * @param {string} machineId
   * @returns {Array} promise with cycles
   */
  async getCycles(
    machineId,
    skip = 0,
    limit = 10,
    isFingerprint = null,
    startTimeFrom = null,
    startTimeTo = null,
    type = null
  ) {
    let params = {
      machineId,
      skip,
      limit,
      type,
      startTimeFrom,
      startTimeTo,
      sort: `${limit > 0 ? "-" : ""}startTime`
    };

    if (typeof isFingerprint === "boolean") {
      params = {
        ...params,
        isFingerprint
      };
    }

    return axios.get(`${this.url}/cycles`, { params }).then(response => {
      return response.data;
    });
  }

  /**
   * Get sub cycle data by machine
   * Params:
   * @param {string} _cycleUuid
   * @returns {Array} promise with info subcyle big data
   */
  async getSubCycles(_cycleUuid, skip = 0, limit = 100) {
    const params = {
      cycleUuid: _cycleUuid,
      skip,
      limit,
      sort: "-startTime"
    };
    return axios.get(`${this.url}/subcycles`, { params }).then(response => {
      return response.data.result;
    });
  }

  /**
   * Get sub cycle data by machine
   * Params:
   * @param {string} machineId
   * @param {string} id
   * @param {string} filename, "<timeSerie> subcycle field value"
   * @returns {Array} promise with info subcyle big data
   */
  async getSubCycleData(machineId, id, filename) {
    return axios
      .get(`${this.url}/storage-api/machine-tests/${id}/machines/${machineId}/${filename}`)
      .then(response => {
        return response.data;
      });
  }

  /**
   * Get collisions by machine
   * Params:
   * @param {string} machineId
   * @returns {Array} promise with results
   */
  async getCollisions(machineId, skip = 0, limit = 10, timeFrom = null, timeTo = null) {
    let params = {
      machineId,
      skip,
      limit,
      sort: "-time"
    };

    if (timeFrom && timeTo) {
      params = {
        ...params,
        timeFrom,
        timeTo,
        sort: "+time"
      };
    }

    return axios.get(`${this.url}/collisions`, { params }).then(response => {
      return response.data;
    });
  }
}

export const machineTestReportsApi = new MachineTestReportsApi();
